import axios from "axios";
import { Dispatch, SetStateAction, useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { useUser } from "../../../components/UserContext";
import { toast } from "react-toastify";
import DateFormat from "../../../components/DateFormat";
import Button from "../../../components/Button";
import { DriverLink } from "../../../components/FlagLink";
import { getAbbreviation } from "../../../utils/Standings";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircle } from "@fortawesome/free-solid-svg-icons";

const REntriesTeams = ({
  raceData,
  setUpdateNotifications,
  setUpdate,
  update,
  dates,
  datesO,
  typeChamp,
}: {
  raceData: RaceEntries;
  setUpdateNotifications: Dispatch<SetStateAction<boolean>>;
  setUpdate: Dispatch<SetStateAction<boolean>>;
  update: boolean;
  dates: string[];
  datesO: string[];
  typeChamp: number;
}) => {
  const { t } = useTranslation();
  const { user } = useUser() as any;
  const [showDropdownG, setShowDropdownG] = useState(false);
  const [showDropdownO, setShowDropdownO] = useState(false);
  const [userState, setUserState] = useState(-1);
  const driverJSX = (driver: ReserveDriver | DriverEntry) => {
    return (
      <>
        <Link
          className={`driver ${
            driver.state === 1
              ? "green"
              : driver.state === 2
                ? "orange"
                : driver.state === 3
                  ? "red"
                  : ""
          }`}
          title={driver.username}
          to={`${t("routes:Driver")}/${encodeURIComponent(driver.username)}`}
        >
          <span>{driver.initials}</span>
          {driver.session != null && driver.session === 9 ? (
            <img
              className="checkered"
              src={require(`../../../assets/Images/checked_flag.png`)}
            />
          ) : (
            driver.session != null &&
            driver.state !== 3 &&
            driver.state !== 0 && (
              <span className={`session-${driver.session}`}>
                {driver.session}
              </span>
            )
          )}
        </Link>
      </>
    );
  };

  const sendState = (state: number, session?: number | null) => {
    let token = window.localStorage.getItem("userLogged");
    if (token == null) return;
    axios
      .post(
        `${
          process.env.NODE_ENV === "development"
            ? "http://localhost:5500"
            : "https://ligavirtualf1.es:5500"
        }/api/championship/setDriverState`,
        {
          user,
          token: JSON.parse(token).token,
          state,
          session,
          typeChamp,
        },
      )
      .then(() => {
        if (state === 1) toast.success(`${t("RaceEntrySigned")}`);
        else if (state === 2) toast.success(`${t("RaceEntryDoubt")}`);
        else if (state === 3) toast.success(`${t("RaceEntryAbsent")}`);
        setUpdate(!update);
        setUpdateNotifications((prev) => {
          return !prev;
        });
      })
      .catch(({ response }) => {
        toast.error(`${t("Error!")}`);
        throw new Error(response);
      });
  };
  const handleButtonClickG = () => {
    setShowDropdownG((prevState: any) => !prevState); // Alterna la visibilidad del desplegable
  };
  const handleButtonClickO = () => {
    setShowDropdownO((prevState: any) => !prevState); // Alterna la visibilidad del desplegable
  };
  const handleClickOutsideG = (event: any) => {
    const classes = event.target.className.split(" ");
    // If clicked outside the dropdown, hide the dropdown.
    setShowDropdownG(classes.includes("button-green-lvf1"));
  };
  const handleClickOutsideO = (event: any) => {
    const classes = event.target.className.split(" ");
    // If clicked outside the dropdown, hide the dropdown.
    setShowDropdownO(classes.includes("button-orange-lvf1"));
  };
  useEffect(() => {
    raceData.drivers.forEach((team) => {
      team.drivers.forEach((driver) => {
        if (driver.username == user) {
          setUserState(driver.state);
        }
      });
    });
    // Adds the listener when the component is mounted
    document.addEventListener("click", handleClickOutsideG);
    document.addEventListener("click", handleClickOutsideO);

    // Cleans the listener when the component is disassembled
    return () => {
      document.removeEventListener("click", handleClickOutsideG);
      document.removeEventListener("click", handleClickOutsideO);
    };
  }, []);

  return (
    <div id="race-entries-right-total" className="news-item">
      <div className="flex drivers-container">
        <p className="main-title text-center">
          {t("Teams").toUpperCase()} & {t("Drivers").toUpperCase()}
        </p>
        {user == null ? (
          <p className="red bold">{t("LogInToSignUp")}</p>
        ) : (
          <div id="buttons-container" className="flex-between">
            <Button
              text={t("Register")}
              onClick={() => {
                if (
                  dates.length === 1 ||
                  (typeChamp === 3 &&
                    raceData.config.secondary_type_races === "period")
                )
                  sendState(1);
                handleButtonClickG();
              }}
              className={"button-green-lvf1"}
            />
            {dates.length > 1 &&
              showDropdownG &&
              (typeChamp !== 3 ||
                raceData.config.secondary_type_races != "period") && (
                <div className="dropdown-dates">
                  {dates.map((date, index) => {
                    let state_index: number | null = index + 1;
                    if (dates.length === 1) state_index = null;
                    return (
                      <p onClick={() => sendState(1, state_index)}>
                        <span className={`session-${index + 1}`}>
                          {index + 1}
                        </span>
                        <DateFormat
                          date={date}
                          format={"full-v2"}
                          disaggregated={true}
                        />
                      </p>
                    );
                  })}
                </div>
              )}

            <Button
              text={t("Doubt")}
              onClick={() => {
                if (dates.length === 1 || userState === 1) sendState(2);
                handleButtonClickO();
              }}
              className={"button-orange-lvf1"}
            />
            {dates.length > 1 &&
            showDropdownO &&
            (userState === 0 || userState === 3) ? (
              <div className="dropdown-dates">
                {dates.map((date, index) => {
                  let state_index: number | null = index + 1;
                  if (dates.length === 1) state_index = null;
                  return (
                    <p onClick={() => sendState(2, state_index)}>
                      <span className={`session-${index + 1}`}>
                        {index + 1}
                      </span>
                      <DateFormat
                        date={date}
                        format={"full-v2"}
                        disaggregated={true}
                      />
                    </p>
                  );
                })}
              </div>
            ) : null}

            <Button
              text={t("Absence")}
              onClick={() => {
                sendState(3);
              }}
              className={"button-red-lvf1"}
            />
          </div>
        )}
      </div>
      <div id="driver-entries-container">
        {raceData.drivers.map((team, index: number) => {
          return team.drivers.map((driver_, index: number) => {
            return (
              <div key={index} className="num-driver">
                <Link
                  className="team-car"
                  to={`${t("routes:Team")}/${encodeURIComponent(
                    team.drivers[0].team_name,
                  )}`}
                >
                  <img
                    alt={team.drivers[0].team_name}
                    title={team.drivers[0].team_name}
                    src={`/assets/TeamChampionship/${
                      team.team_championship_id
                    }.png?dummy=${Math.floor(Math.random() * 1001)}`}
                  />
                </Link>
                <span
                  className="driver-num"
                  style={{
                    background: driver_.main_color,
                    color: driver_.secondary_color,
                  }}
                >
                  {driver_.number == null ? "#" : driver_.number}
                </span>
                {driver_.username == null ? (
                  <span>TBA</span>
                ) : (
                  <DriverLink
                    flag_code={driver_.driver_flag}
                    flag_name={driver_.driver_flag_name}
                    name={driver_.username}
                    nickname={driver_.username}
                    abbreviation={getAbbreviation(driver_.username)}
                  />
                )}
                <FontAwesomeIcon
                  icon={faCircle}
                  className={
                    driver_.state === 1
                      ? "green"
                      : driver_.state === 2
                        ? "orange"
                        : driver_.state === 3
                          ? "red"
                          : ""
                  }
                />
              </div>
            );
          });
        })}
      </div>
      {raceData.reserve_drivers?.length > 0 && (
        <div id="reserve-drivers-container">
          <p className="backgrounded-title text-center">
            {t("ReserveDrivers").toUpperCase()}
          </p>
          <div className="text-center">
            {raceData.reserve_drivers?.map((driver, index) => {
              return <span key={index}>{driverJSX(driver)}</span>;
            })}
          </div>
        </div>
      )}
    </div>
  );
};

export default REntriesTeams;
